import { FiltroCoSeguimientoPedido } from './../dominio/FiltroCoSeguimientoPedido';
import { Injectable, Inject } from '@angular/core';
import { AppConfig } from 'src/environments/appconfig';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ParametroPaginacionGenerico } from 'src/app/util/ParametroPaginacionGenerico';
import { DtoCoDocumentoCobrar } from '../../codocumento/dominio/DtoCoDocumentoCobrar';
import { UHttpsClient } from '../../../../seguridad/seguridad/uhttpsClient';

@Injectable()
export class CoSeguimientoPedidoServicio {

    private url = `${this.config.getEnv('proxy')}spring/comercial/codocumentoseguimiento/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public obtenerPedidoDetalle(filtro: FiltroCoSeguimientoPedido): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}obtenerPedidoDetalle`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());  
    }

    public obtenerDocumento(filtro: FiltroCoSeguimientoPedido): Promise<DtoCoDocumentoCobrar[]> {
        return this.http.post(`${this.url}obtenerDocumento`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoCoDocumentoCobrar[];
            })
            .catch(error => []);
    }

    

   
}

